import axios from "axios";
import IO from "socket.io-client";

import Config from "../config";
import { handleNetworkError } from '../utils/networkErrorHandler';

export const socket = null;
export const api = axios.create({
    baseURL: ''
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        handleNetworkError(error);
        return Promise.reject(error);
    }
);

export default api;
